export const QTY_DEFAULT = 1;
export const QTY_STEP_VOLUME = 0.5;
export const QTY_STEP_PIECE = 1;
export const QTY_MIN_VOLUME = 0.5;
export const QTY_MIN_PIECE = 1;
export const CENTS_PER_EUR = 100;
